import { Pause } from "lucide-react";

import { Callout, RobotoButton } from "@/shared/foundation/primitives";

import styles from "./IngestionRulePages.module.css";

/**
 * Says a rule's saved action is switched off. `onResume` turns it back on;
 * without it, no Resume button is offered.
 */
export function PausedBanner({
  actionName,
  onResume,
  resuming = false,
}: {
  actionName: string;
  onResume?: () => void;
  resuming?: boolean;
}) {
  return (
    <Callout variant="warning" role="status" data-testid="auto-ingest-paused">
      <div className={styles.pausedRow}>
        <Pause size={16} aria-hidden="true" className={styles.pausedIcon} />
        <span className={styles.pausedText}>
          <strong>Auto-ingest is paused.</strong> Saved action{" "}
          <code>{actionName}</code> isn&rsquo;t running.
        </span>
        {onResume !== undefined && (
          <RobotoButton
            variant="secondary"
            size="sm"
            onClick={onResume}
            loading={resuming}
          >
            Resume
          </RobotoButton>
        )}
      </div>
    </Callout>
  );
}
